<template>
 <div>
    <video-player :options="playerOptions">
    </video-player>
</div>

</template>

<script>
    import { videoPlayer } from 'vue-video-player'

    export default {
        props: ['video'],
        name: 'feedback',
        components: {
            'video-player': videoPlayer
        },
        data() {
                return {
                playerOptions: {
                  start: 0,
                  sources: [{
                    type: 'video/webm',
                    src: this.video
                }],
            }
        }
    },
 
}


</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Feedback.vue?3e3f0198